<template>
  <b-row>
    <b-col md="12">
      <b-card-actions
        ref="crdResumen"
        action-refresh
        :title="`Estado de Cuenta -  ${matricula}`"
        @refresh="loadResumen();"
      >
        <b-card-body>
          <b-list-group v-if="dtResumen!=null">
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Ultimo cuatrimestre contratado
              <h5>
                {{ (dtResumen.lastPeriodo !=null) ? dtResumen.lastPeriodo : 'Inscripción' }}
              </h5>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              APORTACIONES:
              <b>{{ (dtResumen.aportaciones!=null) ? formatMoney(dtResumen.aportaciones) : '0.00' }} .mxn</b>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Solicitudes
              <b-badge
                variant="primary"
                pill
              >
                {{ dtResumen.requests }}
              </b-badge>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              CARGOS
              <b class="text-danger">{{ (dtResumen.cargos!=null) ? formatMoney(dtResumen.cargos) : '0.00' }} .mxn</b>

            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Parcialidades: <b>{{ (dtResumen.parcialidades!=null) ? dtResumen.parcialidades : 'N/A' }}</b>
              <span> Total Parcializado:</span>
              <b>{{ (dtResumen.p_cargos!=null) ? formatMoney(dtResumen.p_cargos) : '0.00' }} .mxn</b>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              COMPROBANTES REGISTRADOS:
              <H5>{{ dtResumen.transacciones }}</H5>
            </b-list-group-item>
          </b-list-group>
        </b-card-body>
        <b-card-body v-show="datosecs.length > 0">
          <b-table
            class="position-relative"
            responsive
            :items="datosecs"
            :fields="sfields"
            show-empty
            empty-text="No cuenta con estado de cuenta vigente"
          >
            <!-- status-->
            <template #cell(status)="row">
              <b-badge :variant="frmstatus(row.item.status).color">
                {{ frmstatus(row.item.status).text }}
              </b-badge>
            </template>
            <!-- Saldo actual -->
            <template #cell(monto)="row">
              <b-media vertical-align="center">
                {{ formatMoney(row.item.monto) }}
              </b-media>
            </template>
            <!-- activo -->
            <template #cell(activo)="row">
              <b-media vertical-align="center">
                <small>{{ (row.item.activo==1) ? 'SI' : 'NO' }}</small>
              </b-media>
            </template>
            <!-- Egresado -->
            <template #cell(egresado)="row">
              <b-media vertical-align="center">
                <small>{{ (row.item.egresado==1) ? 'SI' : 'NO' }}</small>
              </b-media>
            </template>
            <!-- tipo de insc -->
            <template #cell(t_inscripcion)="row">
              <b-media vertical-align="center">
                <small>{{ row.item.t_inscripcion }}</small>
              </b-media>
            </template>
            <!-- registrado -->
            <template #cell(fecha)="data">
              <b-media vertical-align="center">
                <small>{{ data.item.fecha }}</small>
              </b-media>
            </template>
          </b-table>
        </b-card-body>
      </b-card-actions>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCardBody,
  BRow,
  BCol,
  BListGroup,
  BListGroupItem,
  BBadge,
  BTable,
  BMedia,
} from 'bootstrap-vue'
import { ref, onMounted, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { formatMoney, frmstatus } from '@core/utils/filter'
import { rolesActions } from '@core/mixins/account-data/roles'
import { requestEC } from './useEstadoCuenta'

export default {
  components: {
    BCardBody,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    BBadge,
    BCardActions,
    BTable,
    BMedia,
  },
  mixins: [rolesActions],
  props: {
    matricula: {
      type: [Number, null],
      default: () => null,
    },
  },
  setup(props) {
    const toast = useToast()
    const dtResumen = ref(null)
    const crdResumen = ref(null)
    const datosecs = ref([])
    const sfields = ref([
      {
        key: 'activo',
      },
      {
        key: 'egresado',
      },
      {
        key: 't_inscripcion', label: 'Tipo', sortable: true,
      },
      {
        key: 'monto', label: 'Saldo Actual',
      },
      {
        key: 'fecha', label: 'Registrado',
      },
      {
        key: 'status',
      },
      {
        key: 'plan_studios',
      },
    ])
    const isbusy = ref(false)

    // const Reload = () => {
    //   ReloadECS(props.matricula).then(response => {
    //     datosecs.value = response.datos
    //   }, error => {
    //     toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'Error en petición [Catalogo de Plan de Pagos]',
    //         text: error,
    //         icon: 'AlertCircleIcon',
    //         variant: 'danger',
    //       },
    //     },
    //     { timeout: 10000 })
    //   })
    // }

    const loadResumen = () => {
      try {
        // Validar que props.matricula sea numérico
        const matriculaValue = Number(props.matricula)

        // eslint-disable-next-line no-restricted-globals
        if (isNaN(matriculaValue) || matriculaValue < 1000) {
          throw new Error('La matrícula debe ser un valor numérico positivo y mayor a 4 digitos.')
        }

        // Mostrar el loader
        crdResumen.value.showLoading = true

        // Realizar la solicitud
        requestEC(matriculaValue).then(
          response => {
            crdResumen.value.showLoading = false
            dtResumen.value = response.datos
          },
          error => {
            crdResumen.value.showLoading = false
            toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'Error en petición [Estado de cuenta]',
                  text: error,
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              },
              { timeout: 10000 },
            )
          },
        )
      } catch (error) {
        crdResumen.value.showLoading = false
        toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Error CATCH - EstadoCuenta',
              text: error.message || 'Ocurrió un error inesperado.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 },
        )
      }
    }

    watch(
      () => props.matricula,
      value => {
        const matriculaValue = Number(value)
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(matriculaValue) && matriculaValue >= 1000) {
          loadResumen()
        }
      },
    )

    onMounted(
      () => {
        loadResumen()
      },
    )

    return {
      // functions
      formatMoney,
      loadResumen,
      crdResumen,
      // Reload,
      frmstatus,
      // data
      dtResumen,
      sfields,
      datosecs,
      // flags
      isbusy,
    }
  },
}
</script>
